"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NewPasswordController_js_1 = require("./NewPasswordController.js");
exports.NewPasswordController = NewPasswordController_js_1.NewPasswordController;



//////////////////
// WEBPACK FOOTER
// ./scripts/core/password_reset/controllers/index.js
// module id = 333
// module chunks = 0